import React, { RefObject } from 'react'

export default (): RefObject<HTMLInputElement> => React.createRef()
